import React from 'react';
import { CalculatorIcon, LockIcon, PencilIcon, ShieldCheckIcon } from 'lucide-react';
type TagKind = 'editable' | 'readonly' | 'calculated' | 'system';
const tags: Record<TagKind, {
  label: string;
  Icon: typeof LockIcon;
  cls: string;
}> = {
  editable: {
    label: 'Editable',
    Icon: PencilIcon,
    cls: 'bg-connect-blueSoft text-connect-blueDark'
  },
  readonly: {
    label: 'Read-only',
    Icon: LockIcon,
    cls: 'bg-status-noneBg text-status-noneInk'
  },
  calculated: {
    label: 'Calculated',
    Icon: CalculatorIcon,
    cls: 'bg-status-okBg text-status-okInk'
  },
  system: {
    label: 'System-controlled',
    Icon: ShieldCheckIcon,
    cls: 'bg-note-noteBg text-note-noteInk'
  }
};
export function FieldTag({
  kind
}: {
  kind: TagKind;
}) {
  const {
    label,
    Icon,
    cls
  } = tags[kind];
  return <span className={`inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded px-1.5 py-0.5 font-connect text-[10.5px] font-medium normal-case ${cls}`} data-id="element-453" data-mp="nz23be8egoib">
      <Icon className="h-3 w-3" aria-hidden="true" data-id="element-454" data-mp="3rgtzz5xhdwmu" />
      {label}
    </span>;
}